import React from 'react';

import { Box } from '@mui/material';

import {
    FaBuilding,
    FaUsers,
    FaBalanceScale
} from 'react-icons/fa';

import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';

import Header from '../../Common/Header/Header';
//import ChartsContainer from '../Common/ChartsContainer';
import IgdChartsContainer from '../Common/IgdChartsContainer';
import IDCRAS from './IDCRAS';
import IDCREAS from './IDCREAS';
import IDCONSELHO from './IDCONSELHO';

const menus = [
    {
        title: 'ID CRAS',
        path: '/governanceroom/dashboardigd/SocialAssistanceSurveillance/idcras',
    },
    {
        title: 'ID CREAS',
        path: '/governanceroom/dashboardigd/SocialAssistanceSurveillance/idcreas',
    },
    {
        title: 'ID CONSELHO',
        path: '/governanceroom/dashboardigd/SocialAssistanceSurveillance/idconselho',
    }
];

const titleMap = {
    '/governanceroom/dashboardigd/SocialAssistanceSurveillance/idcras':
        'Indicadores Gerais do IDCRAS',

    '/governanceroom/dashboardigd/SocialAssistanceSurveillance/idcreas':
        'Indicadores Gerais do IDCREAS',

    '/governanceroom/dashboardigd/SocialAssistanceSurveillance/idconselho':
        'Indicadores Gerais do IDCONSELHO'
};

const SocialAssistanceSurveillance = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardigd');
    };

    return (
        <Box>

            <Header
                menus={menus}
                onHomeClick={handleHomeClick}
            />

            <Box className="content">

                <IgdChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >

                    <Routes>

                        <Route
                            path="/"
                            element={
                                <Navigate
                                    to="idcras"
                                    replace
                                />
                            }
                        />

                        <Route
                            path="idcras"
                            element={<IDCRAS />}
                        />

                        <Route
                            path="idcreas"
                            element={<IDCREAS />}
                        />

                        <Route
                            path="idconselho"
                            element={<IDCONSELHO />}
                        />

                    </Routes>

                </IgdChartsContainer>

            </Box>

        </Box>
    );
};

export default SocialAssistanceSurveillance;